// extracted by mini-css-extract-plugin
export default {"modalHeader":"Modal_Header_modalHeader__v84eh","hasCloseBtn":"Modal_Header_hasCloseBtn__5vWbO","closeButton":"Modal_Header_closeButton__+5qYW"};